import React, { createContext, useContext, useState } from "react";

const LogOutStateContext = createContext();

export const LogOutStateProvider = ({ children }) => {
  const [showOverlayLogOut, setShowOverlayLogOut] = useState({overlay: false});

  return (
    <LogOutStateContext.Provider value={{ showOverlayLogOut, setShowOverlayLogOut}}>
      {children}
    </LogOutStateContext.Provider>
  );
};

export const useLogOutStateContext = () => useContext(LogOutStateContext);
